import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export class IPackageIncidentListItem {
  id: string | number;
  date: string;
  client: string | number;
  server: string | number;
  file: string;
  message: string;
  url: string;
  getParams: string;
  postParams: string;
  user: string | number;
  lat: string;
  loc: string;
  level: number;
  packageId: number;
}

export class IPackageIncidentListResponse extends IPagination {
  @Type(() => IPackageIncidentListItem)
  results: IPackageIncidentListItem[];
}

export class IPackageIncidentsQueryDto extends IQueryPaginationDto {
  package_id?: string | number;
}
